import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AccordionModule, ModalModule, TabsModule, CarouselModule, ButtonsModule
} from 'ngx-bootstrap';
import { EmitterService } from '../../services/emitter.service';
import { PopupComponent } from '../popup/popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HorizontalScrollDirective } from '../scrollBar/scrollBar.directive';
import { SelectionListComponent } from '../selectionList';
import { PaymentComponent } from '../../../payment/payment.component';
import { DoubleDigitPipe } from '../pipes/DoubleDigit.pipe';
import { SpacePipe } from '../pipes/SpacePipe.pipe';
import { ReloadDirective } from '../../directive/reload.directive';
import { LoaderComponent } from './../../../loader/loader.component';
import { DrawerComponent } from '../drawer/drawer.component';
import { ClockCountDownTimerComponent } from '../clock-count-down-timer/clock-count-down-timer.component';
import { ProgressCircleComponent } from '../progress-circle/progress-circle.component';
import { PlanCardComponent } from '../../components/planCard/planCard.component';
import { PlanCardMappingComponent } from '../../components/planCardMapping/planCardMapping.component';
import { TooltipDirective } from '../../../common/directive/tooltip.directive';
import { MaskedDateFormatterPipe } from '../pipes/masked-date-formatter.pipe';
import { NeedHelpDrawerComponent } from 'src/app/shared/components/need-help-drawer/need-help-drawer.component';

// Application wide providers
const APP_PROVIDERS = [
    EmitterService,
];
@NgModule({
    declarations: [
        PopupComponent,
        HorizontalScrollDirective,
        SelectionListComponent,
        PaymentComponent,

        DoubleDigitPipe,
        SpacePipe,
        ReloadDirective,
        LoaderComponent,
        DrawerComponent,
        ClockCountDownTimerComponent,
        ProgressCircleComponent,
        PlanCardComponent,
        PlanCardMappingComponent,
        TooltipDirective,
        MaskedDateFormatterPipe,
        NeedHelpDrawerComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AccordionModule.forRoot(),
        CarouselModule.forRoot(),
        ButtonsModule.forRoot()
    ],
    exports: [
        ModalModule,
        ReactiveFormsModule,
        TabsModule,
        PopupComponent,
        HorizontalScrollDirective,
        AccordionModule,
        SelectionListComponent,
        PaymentComponent,
        CarouselModule,
        DoubleDigitPipe,
        SpacePipe,

        ButtonsModule,
        ReloadDirective,
        LoaderComponent,
        DrawerComponent,
        ClockCountDownTimerComponent,
        ProgressCircleComponent,
        PlanCardComponent,
        PlanCardMappingComponent,
        TooltipDirective,
        MaskedDateFormatterPipe,
        NeedHelpDrawerComponent
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [APP_PROVIDERS]
        };
    }
}
